import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { ISearchInHouseInventoriesData } from '../../../types';
import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track the mutation key for scan package to get in-house inventory
 * details
 */
const MUT_SCAN_PACKAGE_TO_GET_IN_HOUSE_INVENTORY_DETAILS =
  'scan-package-to-get-in-house-inventory-details-mutation-key';

interface IUpdateBidMutationParam {
  onSuccess: (inventoryData: ISearchInHouseInventoriesData) => void;
  onError: (err: IApiError) => void;
}

/**
 * React Query mutation function for getting in-house inventory details after
 * scanning a package, if any.
 */
export const useSearchInHouseInventoriesMutation = ({
  onSuccess,
  onError,
}: IUpdateBidMutationParam) => {
  const {
    isPending,
    isError,
    error,
    data,
    mutate,
    reset: resetInHouseScanPackage,
  } = useMutation({
    mutationKey: [MUT_SCAN_PACKAGE_TO_GET_IN_HOUSE_INVENTORY_DETAILS],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.getInHouseInventoryDetails,
    onSuccess,
    onError,
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetInHouseScanPackage,
    scanPackageToRemove: mutate,
  };
};
